<template>
    <v-row v-if="!$store.getters.progress" class="pb-offset ma-0">
        <v-col cols="12" class="pt-4">
            <v-card class="flex pa-0 background-2 round-card">
                <v-card-title class="pa-3">
				    <p class="pl-2 pl-xl-3">Modifica Listino</p>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-divider></v-divider>
                <v-container fluid :class="{'px-3': $vuetify.breakpoint.mdAndUp, 'px-0': $vuetify.breakpoint.smAndDown}">
                    <fields-generator
                        class="pt-3"
                        :fieldsset.sync="fieldsset"
                        :model="model"
                        ref="fieldsgenerator"
                    ></fields-generator>
                    <small class="px-4">* Indica i campi obbligatori</small>
                </v-container>
                <v-tooltip top>
                    <template v-slot:activator="{ on: tooltip }">
                        <v-fab-transition>
                            <v-btn
                                v-on="{ ...tooltip }"
                                @click.native="updateModel()"
                                :loading="saved"
                                color="primary"
                                dark
                                absolute
                                bottom
                                right
                                fab>
                                <v-icon>sync</v-icon>
                            </v-btn>
                        </v-fab-transition>
                    </template>
                    <span>Aggiorna</span>
                </v-tooltip>                
            </v-card>
        </v-col>

        <v-col cols="12">
            <crud
                ref="crud"
                title='Prodotti Listino'
                action-icon='widgets'
                model-def='pricelist-product-pricelist'
                :sub-filters="subFilters"
                :default-input="{pricelistable_id: id, pricelistable_type: 'pricelist'}"
                action-position='absolute'
                :crud-dialog="true"
                class="mb-4"
                save-and-new
                actions-expand
                @update:actionsExpand="toggleActionsExpand($event)"
                @update:selected="selected = $event">
                
                <template slot="actions-expand">
		            <v-slide-y-transition>
                        <v-card class="background-2 py-2" elevation="0" v-show="expand">
                            <v-row class="pl-4 ma-0">
                                <div class="body-2">Inserisci l'importo da incrementare/decrementare ai prezzi (usato anche per duplicazione)</div>
                            </v-row>
                            <v-row class="pl-4">
                                <v-col lg="3" cols="10">
                                    <v-row class="pl-4">
                                        <v-text-field
                                            label="Importo"
                                            type="number"
                                            v-model.number="increment"
                                            ref="increment"
                                            v-validate="'numeric'"
                                            :error-messages="errors.collect('Importo')"
                                            hint="Valori negativi per ridurre il prezzo"
                                            persistent-hint
                                            dense
                                            outlined>
                                        </v-text-field>
                                        <v-tooltip top v-if="canIncrement">
                                            <template v-slot:activator="{ on: tooltip }">
                                                <v-btn @click="incrementPrice()" v-on="{ ...tooltip }" text icon color="success" class="ml-4">
                                                    <v-icon>playlist_add</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Incrementa</span>
                                        </v-tooltip>
                                    </v-row>
                                </v-col>
                            </v-row>

                            <v-row class="pl-4 ma-0 pt-4">
                                <div class="body-2">Inserisci la percentuale da incrementare/decrementare ai prezzi (usato anche per duplicazione)</div>
                            </v-row>
                            <v-row class="pl-4">
                                <v-col lg="3" cols="10">
                                    <v-row class="pl-4">
                                        <v-text-field
                                            label="Importo %"
                                            type="number"
                                            suffix="%"
                                            v-model.number="incrementPerc"
                                            ref="incrementPerc"
                                            v-validate="'numeric'"
                                            :error-messages="errors.collect('Importo %')"
                                            hint="Valori negativi per ridurre il prezzo"
                                            persistent-hint
                                            dense
                                            outlined>
                                        </v-text-field>
                                        <v-tooltip top v-if="canIncrementPerc">
                                            <template v-slot:activator="{ on: tooltip }">
                                                <v-btn @click="incrementPricePerc()" v-on="{ ...tooltip }" text icon color="success" class="ml-4">
                                                    <v-icon>playlist_add</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Incrementa in %</span>
                                        </v-tooltip>
                                    </v-row>
                                </v-col>
                            </v-row>

                            <v-row class="pl-4 ma-0 pt-4">
                                <div class="body-2">Inserisci le date di validità dei prezzi (usato anche per duplicazione)</div>
                            </v-row>
                            <v-row class="pl-4">
                                <v-col lg="3" cols="10">
                                    <v-row class="pl-4">
                                        <gmh-date-picker
                                            v-model="start_date"
                                            label="Data di inizio"
                                        ></gmh-date-picker>
                                    </v-row>
                                </v-col>
                                <v-col lg="3" cols="10">
                                    <v-row class="pl-4">
                                        <gmh-date-picker
                                            v-model="end_date"
                                            label="Data di fine"
                                        ></gmh-date-picker>

                                        <v-tooltip top>
                                            <template v-slot:activator="{ on: tooltip }">
                                                <v-btn @click="editDates()" v-on="{ ...tooltip }" text icon color="success" class="ml-4">
                                                    <v-icon>playlist_add</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Modifica date di validità</span>
                                        </v-tooltip>
                                    </v-row>
                                </v-col>
                            </v-row>
                            <v-row class="pl-8 pt-4 align-center">
                                <v-btn color="info" @click="selectAllItems()" small>
                                    <v-icon left small>{{ selectAll ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}</v-icon>
                                    {{ selectAll ? 'Deseleziona tutti' : 'Seleziona tutti'}}
                                </v-btn>
                                <v-chip class="ml-4" small :color="selectAll || selected.length > 0 ? 'primary' : 'grey'" outlined>
                                    <v-icon left small>mdi-check-circle</v-icon>
                                    {{ selectAll ? 'Tutti selezionati' : selected.length + ' selezionati' }}
                                </v-chip>
                            </v-row>

                            <v-row class="pl-5 pt-5 mx-0">
                                <div class="body-2">Aggiunti tutte le varianti dei prodotti selezionati (se il prodotto non ha varianti sarà aggiunto il prodotto semplice)</div>
                            </v-row>
                            <v-row class="pl-2 pb-2">
                                <v-col cols="10">
                                    <v-row class="ma-0">
                                        <fields-generator
                                            class="pt-3"
                                            :fieldsset.sync="product_fieldsset"
                                            :model="selectedProduct"
                                            ref="fieldsgenerator"
                                        ></fields-generator>         
                                        <v-tooltip top v-if="selectedProduct.product_id">
                                            <template v-slot:activator="{ on: tooltip }">
                                                <v-btn @click="addVariants()" v-on="{ ...tooltip }" text icon color="success" class="ml-4 ma-auto">
                                                    <v-icon>playlist_add</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Aggiungi Varianti</span>
                                        </v-tooltip>
                                    </v-row>
                                </v-col>
                            </v-row>

                            <v-row class="pl-5 mx-0">
                                <div class="body-2">Duplica i prezzi selezionati con possibilità di variazione</div>
                            </v-row>
                            <v-row class="pl-5 pb-6">
                                <v-col cols="10">
                                    <v-tooltip top v-if="selected.length > 0 || selectAll">
                                        <template v-slot:activator="{ on: tooltip }">
                                            <v-btn @click="openDuplicateDialog()" v-on="{ ...tooltip }" color="primary">
                                                <v-icon left>mdi-content-copy</v-icon>
                                                Duplica Selezionati
                                            </v-btn>
                                        </template>
                                        <span>Duplica i prezzi selezionati</span>
                                    </v-tooltip>
                                </v-col>
                            </v-row>
                        <v-divider></v-divider>
                        </v-card>
                    </v-slide-y-transition>
                </template>

            </crud>
        </v-col>

        <v-dialog v-model="confirmIncrement" max-width="600" persistent>
            <v-card class="background-2 round-card">
                <v-card-title primary-title class="subtitle-1 background-2">Conferma incremento</v-card-title>
                <v-divider></v-divider>
                <v-card-text style="min-height: 100px;" class="pt-4 body-2">Sei sicuro di effettuare questo incremento massivo?</v-card-text>
                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click.native.stop="confirmIncrement = false">Annulla</v-btn>
                    <v-btn text color="info" @click.native.stop="updateIncrement()" :loading="loading">Procedi</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        
        <v-dialog v-model="confirmUpdateDates" max-width="600" persistent>
            <v-card class="background-2 round-card">
                <v-card-title primary-title class="subtitle-1 background-2">Conferma modifica</v-card-title>
                <v-divider></v-divider>
                <v-card-text style="min-height: 100px;" class="pt-4 body-2">Sei sicuro di effettuare questa modifica massivo delle date di valità?</v-card-text>
                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click.native.stop="confirmUpdateDates = false">Annulla</v-btn>
                    <v-btn text color="info" @click.native.stop="updateDates()" :loading="loading">Procedi</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        

        <v-dialog v-model="confirmAddVarints"
            max-width="870px"
            persistent
			scrollable
            :fullscreen="$vuetify.breakpoint.xsOnly">
            <v-card class="background-2 round-card">
                <v-card-title class="pa-3">
				    <p class="pl-2 pl-xl-3">Conferma aggiunta delle varianti</p>
                    <v-spacer></v-spacer>
                </v-card-title>   
                <v-divider></v-divider>
                <v-card-text class="pa-0">
                    <v-container>
                        <fields-generator class="mt-4"
                            :fieldsset.sync="pricelist_product_variant_fieldsset"
                            :model="variants"
                            ref="addVariants"
						></fields-generator>
						<div><small class="pl-4">* Indica i campi obbligatori</small></div>
                    </v-container>

                </v-card-text>
                <v-card-text style="min-height: 100px;" class="pt-4 body-2">Sei sicuro di aggiugere tutte le varianti disponibili per i prodotti selezionati?</v-card-text>
                <v-divider></v-divider>

                <v-card-actions class="px-2">
                    <v-spacer></v-spacer>
                    <v-btn color="error" text @click.native.stop="confirmAddVarints = false">Chiudi</v-btn>
                    <v-btn color="primary" text :loading="loading" @click.native="updateVariants()">Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="confirmDuplicate" max-width="600" persistent>
            <v-card class="background-2 round-card">
                <v-card-title primary-title class="subtitle-1 background-2">Conferma duplicazione</v-card-title>
                <v-divider></v-divider>
                <v-card-text style="min-height: 100px;" class="pt-4 body-2">
                    Sei sicuro di voler duplicare {{ selectAll ? 'tutti i' : selected.length }} prezzi selezionati?
                    <div class="mt-3" v-if="start_date || end_date || increment || incrementPerc">
                        <strong>Variazioni che verranno applicate:</strong>
                        <ul class="mt-1">
                            <li v-if="start_date">Data inizio: {{ $eventBusUtility.formatDate(start_date) }}</li>
                            <li v-if="end_date">Data fine: {{ $eventBusUtility.formatDate(end_date) }}</li>
                            <li v-if="increment">Variazione importo: {{ increment }}</li>
                            <li v-if="incrementPerc">Variazione percentuale: {{ incrementPerc }}%</li>
                        </ul>
                    </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click.native.stop="confirmDuplicate = false">Annulla</v-btn>
                    <v-btn text color="info" @click.native.stop="executeDuplicate()" :loading="loading">Duplica</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


		<confirm-dialog
			:confirmModel="confirmExit"
			:mainTitle="$trans('save_primary_message')"
			:secondTitle="$trans('save_secondary_message')"
			@update:confirmModel="confirmExit = false"
            :exit="{label:'Esci', color:'error'}"
			:atConfirm="updateModel"
			:atExit="exit"
		></confirm-dialog>
    </v-row>
</template>

<script>

    export default {
        name: 'pricelist-edit',
        props: {
            id: Number,
            modelDef: String,
            redirect: Object,
        },

        data() {
            return {
                fieldsset: {},
                pricelist_product_variant_fieldsset: {},
                model: {},
                variants: {},
                saved: false,
                confirmExit: false,
                next: null,
                loading: false,
                expand: false,
                search: '',
                subFilters: {'pricelists': this.id},
                // actions
                incrementType: null,
                increment: 0,
                incrementPerc: 0,
                confirmIncrement: false,
                confirmAddVarints: false,
                confirmUpdateDates: false,
                selectAll: false,
                selected: [],
                selectedProduct: {},
                start_date: '',
                end_date: '',
                // duplicate functionality
                confirmDuplicate: false,
                product_fieldsset: {
                    fields: [
                        {
                            'label': 'Prodotti',
                            'type': 'belongsTo',
                            'relation_field': 'name',
                            'key': 'product_id',
                            'async': true,
                            'async_url': 'async-products',
                            'searchKeys': ['code','subtitle','barcode','alias'],
                            'class': 'col-12',
                            'model': 'Product',
                            'options': [],
                            'multiple': true,
                            'hide_details': true
                        }
                    ]
                }
            }
        },

        beforeRouteLeave(to, from, next) {
            if(this.$store.getters.modelEdited) {
                this.confirmExit = true
                this.next = next
            } else {
                next()
            }
        },

        watch: {
            modelForWatcher: {
                handler(newVal, oldVal) {
                    if(!_.isEmpty(oldVal) && !this.$store.getters.progress && (JSON.stringify(newVal) !== JSON.stringify(this.oldVal))) {
                        this.$store.commit('setModelEdited', true)
                    }
                },
                deep: true,
            },        
        },

        created() {

            this.axios.get('pricelists/' +this.id + '/edit').then(response => {
                // get body data
                this.fieldsset = response.data.fields
                this.model = response.data.model

                this.$store.commit('endProgress')
            
            }, response => {
                // error callback
            })

        },

        beforeDestroy() {
            this.$store.commit('setModelEdited', false)
        },
        
        computed: {
            
            modelForWatcher() {
                return _.cloneDeep(this.model);
            },

            canIncrement() {
                return this.increment != 0 && this.increment != ''
            },
            
            canIncrementPerc() {
                return this.incrementPerc != 0 && this.incrementPerc != ''
            },

        },


        methods: {

            addVariants() {
				this.axios.get('pricelist-product-pricelist/create').then(response => {
                    let filter_fields = response.data.fields.fields.filter((field) => field.key != 'product_id')
					this.pricelist_product_variant_fieldsset = {'fields': filter_fields}
                    this.confirmAddVarints = true
				}, response => {
					// error callback
				})

            },

            updateVariants() {
                this.$refs.addVariants.$validator.validateAll().then(result => {
                    if (!result) {
                        return false
                    }                
                    this.loading = true
                    let dataObject = {
                        'products': this.selectedProduct.product_id,
                        ...this.variants,
                    }

                    this.axios.post('pricelists-addvariants/' + this.model.id, dataObject).then(response => {
                        this.loading = false
                        this.confirmAddVarints = false
                        this.variants = {}
                        this.selectedProduct = {}
                        this.$eventBusUtility.$emit('refreshTable_pricelist-product-pricelist')

                    }, response => {
                        // error callback
                        this.loading = false
                    })
				}).catch(() => {

				})
            },

            selectAllItems() {
                this.selectAll = !this.selectAll
            },

            incrementPrice() {
                this.$refs.increment.$validator.validateAll().then(result => {
                    if (result) {
                        this.confirmIncrement = true
                        this.incrementType = 'increment'
                    }
                }).catch(() => {
                    
                })
            },

            incrementPricePerc() {
                this.$refs.incrementPerc.$validator.validateAll().then(result => {
                    if (result) {
                        this.confirmIncrement = true
                        this.incrementType = 'incrementPerc'
                    }
                }).catch(() => {

                })                
            },
            
            editDates() {
                this.confirmUpdateDates = true            
            },
            
            updateDates() {
                this.loading = true
                let dataObject = {'start_date': this.start_date, 'end_date': this.end_date}
                if(this.selectAll) {
                    dataObject.all = true
                } else {
                    dataObject.ids = this.selected.map(pricelistproduct => {
                        return pricelistproduct.id
                    })
                }
                
                this.axios.post('pricelists-dates/' + this.model.id, dataObject).then(response => {
                    this.loading = false
                    this.confirmUpdateDates = false
                    this.selectAll = false
					this.$eventBusUtility.$emit('refreshTable_pricelist-product-pricelist')

                }, response => {
                    // error callback
                    this.loading = false
                    this.confirmUpdateDates = false
                })         
            },



            updateIncrement() {
                this.loading = true
                let dataObject = {}
                if(this.selectAll) {
                    dataObject.all = true
                } else {
                    dataObject.ids = this.selected.map(pricelistproduct => {
                        return pricelistproduct.id
                    })
                }
                
                if(this.incrementType == 'increment') {
                    dataObject.increment = this.increment
                } else if(this.incrementType == 'incrementPerc') {
                    dataObject.incrementPerc = this.incrementPerc
                }

                this.axios.post('pricelists-increment/' + this.model.id, dataObject).then(response => {
                    this.loading = false
                    this.confirmIncrement = false
                    this.incrementType = null
                    this.selectAll = false
					this.$eventBusUtility.$emit('refreshTable_pricelist-product-pricelist')

                }, response => {
                    // error callback
                    this.loading = false
                    this.confirmIncrement = false
                })
            },

            openDuplicateDialog() {
                this.confirmDuplicate = true
            },

            executeDuplicate() {
                this.loading = true
                let dataObject = {
                    start_date: this.start_date,
                    end_date: this.end_date
                }

                if(this.selectAll) {
                    dataObject.all = true
                } else {
                    dataObject.ids = this.selected.map(pricelistproduct => {
                        return pricelistproduct.id
                    })
                }

                if(this.increment != 0) {
                    dataObject.increment = this.increment
                } else if(this.incrementPerc != 0) {
                    dataObject.incrementPerc = this.incrementPerc
                }

                this.axios.post('pricelists-duplicate-products/' + this.model.id, dataObject).then(response => {
                    this.loading = false
                    this.confirmDuplicate = false
                    this.selectAll = false
                    // Reset input fields
                    this.start_date = ''
                    this.end_date = ''
                    this.increment = 0
                    this.incrementPerc = 0
                    this.$eventBusUtility.$emit('refreshTable_pricelist-product-pricelist')
                }, response => {
                    // error callback
                    this.loading = false
                })
            },

            toggleActionsExpand(event) {
                this.expand = event
            },


            exit() {
                this.$store.commit('setModelEdited', false)
                this.next()
            },

            updateModel() {
                this.search = ''
                this.confirmExit = false
                this.$refs.fieldsgenerator.$validator.validateAll().then(result => {
                    if (!result) {
                        return false
                    }

                    this.$validator.validateAll().then(result => {
                        if (!result) {
                            return false
                        }

                        this.saved = true

                        this.axios.put(this.modelDef + '/' + this.id, this.model).then(response => {
                            // get body data
                            this.model = {}
                            this.saved = false
                            this.$store.commit('setModelEdited', false)
                            // Got in show
                            if(this.next != null) {
                                this.next()
                            } else {
                                this.$eventBusUtility.chooseRedirect(this.$router, response, this.redirect, this.modelDef)
                            }
                        }, response => {
                            this.saved = false
                            // error callback
                        })
                    }).catch(() => {

                    })
                }).catch(() => {
                    
                })
            },
        },
    }
</script>
